<div class="dialog-container">
  <div class="dialog-header">
    <h2 class="dialog-title">Add Rule Definition</h2>
    <button mat-icon-button class="close-btn" (click)="onCancel()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-body" [formGroup]="form">
    <div class="form-row">

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Name</mat-label>
        <input matInput formControlName="name" placeholder="e.g. Special Discount - Motors" />
        <mat-error *ngIf="form.get('name')?.hasError('required')">Name is required</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Maximum Discount Amount (USD)</mat-label>
        <input matInput formControlName="max_discount_amount" placeholder="e.g. 100" />
        <mat-error *ngIf="form.get('max_discount_amount')?.hasError('required')">Maximum discount amount is
          required</mat-error>
      </mat-form-field>

    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Discount Percent</mat-label>
        <input matInput formControlName="discount_percent" placeholder="e.g. 4" />
        <mat-error *ngIf="form.get('discount_percent')?.hasError('required')">Discount percent is required</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Apply Level</mat-label>
        <mat-select formControlName="apply_level">
          <mat-option *ngFor="let opt of applyLevelOptions" [value]="opt">{{ opt }}</mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('apply_level')?.hasError('required')">Apply level is required</mat-error>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Priority</mat-label>
        <input matInput formControlName="priority" placeholder="e.g. 1" />
        <mat-error *ngIf="form.get('priority')?.hasError('required')">Priority is required</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Stackable</mat-label>
        <mat-select formControlName="stackable">
          <mat-option *ngFor="let opt of stackableOptions" [value]="opt">{{ opt }}</mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('stackable')?.hasError('required')">Stackable is required</mat-error>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Criteria Field</mat-label>
        <input matInput formControlName="criteria_field" placeholder="e.g. item_name" />
        <mat-error *ngIf="form.get('criteria_field')?.hasError('required')">Criteria field is required</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Criteria Value</mat-label>
        <input matInput formControlName="criteria_value" placeholder="e.g. Suspension Mount" />
        <mat-error *ngIf="form.get('criteria_value')?.hasError('required')">Criteria value is required</mat-error>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Exclusive Group (Optional)</mat-label>
        <input matInput formControlName="exclusive_group" placeholder="Leave blank if none" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Organisation ID (Optional)</mat-label>
        <input matInput formControlName="organisation_id" placeholder="Leave blank if none" />
      </mat-form-field>
    </div>

    <!-- Success / Error messages -->
    <div class="status-message success" *ngIf="submitSuccess">
      <mat-icon>check_circle</mat-icon>
      <span>Rule added successfully!</span>
    </div>

    <div class="status-message error" *ngIf="submitError">
      <mat-icon>error</mat-icon>
      <span>{{ submitError }}</span>
    </div>
  </div>

  <div class="dialog-actions">
    <button mat-stroked-button class="btn-cancel" (click)="onCancel()" [disabled]="isSubmitting">Cancel</button>
    <button mat-flat-button class="btn-submit" (click)="onSubmit()" [disabled]="isSubmitting">
      <mat-spinner diameter="16" *ngIf="isSubmitting" class="spinner"></mat-spinner>
      <span>{{ isSubmitting ? 'Submitting...' : 'Submit' }}</span>
    </button>
  </div>
</div>